import Class from './c-content-chart-gantt';
import './c-content-chart-gantt@.vue';

export default Class;
